import { Card } from "../../models/card";
import { cards } from "../../state";
import { GreenGolem } from "../upgrades/greenGolem";
export class MakeGreenGolem extends Card {
}
MakeGreenGolem.displayName = "Green Golem";
MakeGreenGolem.artUrl = "./assets/cards/purplegolem.jpg";
MakeGreenGolem.effect = {
    callback: () => {
        cards.push(new GreenGolem({ x: 150, y: 240 }));
    },
    description: "Craft a Green Golem. This one is raring to go.",
    needsFeedback: true,
};
MakeGreenGolem.destroysOnPlay = true;
